export default "__VITE_ASSET__$A6tR$ve__"